import { USER_OPENED_ACCORDION, USER_CLOSED_ACCORDION } from '../constants';

export function accordionOpenAction(accordionType) {
  return (dispatch) => {
    dispatch({
      type: USER_OPENED_ACCORDION,
      accordionType
    });
  };
}

export function accordionCloseAction(accordionType) {
  return (dispatch) => {
    dispatch({
      type: USER_CLOSED_ACCORDION,
      accordionType
    });
  };
}



/** WEBPACK FOOTER **
 ** ./src/redux/actions/accordion.js
 **/